'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var toPlainJS = exports.toPlainJS = function toPlainJS(obj) {
    return obj && (typeof obj.toJS === 'undefined' ? obj : obj.toJS());
};

exports.default = function (obj) {
    return obj && Object.keys(obj).reduce(function (acc, key) {
        acc[key] = toPlainJS(obj[key]);
        return acc;
    }, {});
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/object/immutableChildrenToJS.js
// module id = 110
// module chunks = 0